import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotBellOff = ({
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Spot=on,_Size=40_svg__a)">
            <path
                fill={spotColor}
                d="M4.857 17.78c1.738-5.087 7.916-9.787 13.373-11.594 5.482-1.818 11.979-.362 16.283 3.888 4.304 4.25 6.402 10.611 5.107 15.97-1.26 5.374-5.757 8.608-9.715 10.583-3.983 1.985-7.428 1.992-11.538.997-4.123-.96-8.301-2.541-10.448-6.26-2.147-3.72-4.824-8.487-3.062-13.584Z"
            />
            <path
                fill={color}
                d="M8.46 25.048v1.1a1.1 1.1 0 0 0 1.1-1.1h-1.1Zm0-6.923h-1.1 1.1Zm6.4-10.964a1.1 1.1 0 1 0 2.2 0h-2.2Zm9.176.152h-1.1c0 .46.285.87.716 1.03l.384-1.03ZM31.53 33.07a1.1 1.1 0 1 0 0-2.2v2.2Zm-1.094-9.946a1.1 1.1 0 0 0 2.2 0h-2.2ZM3.278 1.722a1.1 1.1 0 0 0-1.556 1.556l1.556-1.556Zm33.444 36.556a1.1 1.1 0 1 0 1.556-1.556l-1.556 1.556ZM24.084 31.91a4.093 4.093 0 0 1-4.086 3.864v2.2a6.293 6.293 0 0 0 6.282-5.944l-2.196-.12Zm-4.086 3.864a4.093 4.093 0 0 1-4.086-3.864l-2.197.12a6.293 6.293 0 0 0 6.283 5.944v-2.2Zm-5.185-4.904H8.465v2.2h6.348v-2.2Zm-6.348 0a2.364 2.364 0 0 1-2.367-2.361h-2.2a4.564 4.564 0 0 0 4.567 4.561v-2.2ZM6.098 28.51a2.364 2.364 0 0 1 2.362-2.362v-2.2a4.564 4.564 0 0 0-4.562 4.562h2.2Zm3.462-3.462v-6.924h-2.2v6.924h2.2Zm7.5-17.887a2.94 2.94 0 0 1 2.938-2.936v-2.2a5.14 5.14 0 0 0-5.139 5.136h2.2Zm2.938-2.936a2.937 2.937 0 0 1 2.938 2.936h2.2a5.137 5.137 0 0 0-5.138-5.136v2.2Zm2.938 2.936v.152h2.2V7.16h-2.2Zm.716 1.182a10.443 10.443 0 0 1 6.784 9.782h2.2c0-5.341-3.34-10.024-8.215-11.843l-.77 2.061Zm7.878 22.528h-6.348v2.2h6.349v-2.2Zm-16.717 2.2h10.37v-2.2h-10.37v2.2Zm15.623-14.946v5h2.2v-5h-2.2Zm-20.877 0c0-2.694 1.028-5.185 2.747-7.06L10.684 9.58a12.625 12.625 0 0 0-3.325 8.546h2.2ZM1.722 3.278l35 35 1.556-1.556-35-35-1.556 1.556Z"
            />
        </g>
        <defs>
            <clipPath id="Spot=on,_Size=40_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotBellOff.displayName = "SpotBellOff";
